import { AddEditDealModalProps } from './AddEditDealModal';
import { openModal } from '@core/components/ModalStack';

export async function openAddEditDealModal(props: AddEditDealModalProps) {
  const { AddEditDealModal } = await import('./AddEditDealModal');
  openModal(AddEditDealModal, props);
}
